export const SIZE = 2;
//# sourceMappingURL=constants.js.map